import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PropTypes from 'prop-types';
import ConversionTableCell from './ConversionTableCell';
import ConversionTableCellResult from './ConversionTableCellResult';
import DataprivacyDialog from '../../layout/DataprivacyDialog';

const ConversionTableStructure = ({
  curFrom, curTo, rate, fee, rowdef, border,
}) => (
  <Table>
    <TableHead >
      <TableRow style={{ height: '2rem' }}>
        <ConversionTableCell>{curFrom.value}</ConversionTableCell>
        <ConversionTableCell>{curTo.value}</ConversionTableCell>
      </TableRow>
    </TableHead>
    <TableBody style={border && { borderRight: '1px solid rgba(224, 224, 224, 1)' }}>
      {rowdef.map(row => (
        <TableRow key={row} style={{ height: '2rem' }}>
          <ConversionTableCell>{row}</ConversionTableCell>
          <ConversionTableCell><ConversionTableCellResult fee={fee} rate={rate} amount={row} />
          </ConversionTableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

ConversionTableStructure.propTypes = {
  curFrom: PropTypes.instanceOf(Object).isRequired,
  curTo: PropTypes.instanceOf(Object).isRequired,
  fee: PropTypes.number.isRequired,
  rate: PropTypes.number.isRequired,
  rowdef: PropTypes.array.isRequired,
  border: PropTypes.bool,
};

DataprivacyDialog.defaultProps = {
  border: false,
};


export default ConversionTableStructure;



// WEBPACK FOOTER //
// ./src/components/calculator/conversion-table/ConversionTableStructure.js